import Vue from 'vue';
import VueRouter from 'vue-router';
import VueClipboard from 'vue-clipboard2';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

import 'animate.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import './custom.scss';
import './fontAwesome'

Vue.use(VueRouter);
Vue.use(VueClipboard);
Vue.use(PerfectScrollbar);

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);




